import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import * as Icons from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register({ ...form, role: "driver" });
      toast.success("Account created");
      navigate("/");
    } catch (err) {
      const msg = err.response
        ? formatApiErrorDetail(err.response?.data?.detail)
        : "Can't reach the server right now. Please wait a moment and try again.";
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Create driver account" subtitle="Register to submit your stops and track earnings">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div>
          <Label htmlFor="name">Full name</Label>
          <Input id="name" value={form.name} onChange={set("name")} required className="mt-1.5"
            data-testid="register-name-input" placeholder="Jane Driver" />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={form.email} onChange={set("email")} required className="mt-1.5"
            data-testid="register-email-input" placeholder="you@company.co.uk" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" value={form.password} onChange={set("password")} required
            className="mt-1.5" data-testid="register-password-input" placeholder="••••••••" />
        </div>
        <Button type="submit" className="w-full" disabled={busy} data-testid="register-submit-button">
          {busy ? <Icons.LoaderCircle className="h-4 w-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
      <p className="text-sm text-muted-foreground text-center mt-6">
        Already registered?{" "}
        <Link to="/login" className="text-primary font-medium hover:underline">Sign in</Link>
      </p>
    </AuthShell>
  );
}
